export enum LaneSource {
  Detected = "detected",
  Confirmed = "confirmed",
}
